import { Tab } from "bootstrap";
import React, { useMemo, useState, useEffect } from "react";
import { Badge, Button, Col, Form, Image, InputGroup, Modal, Row, Table, Nav } from "react-bootstrap";
import "../../assets/styles/phone-preview.css";
import ImageShow from "../../Uitiles/ImageShow";
import { getSettings } from "../../services/settingsService";
import { OneKlicksFileSDK } from "../../SDK/OneKlicksFileSDK";
import { oneKlicks } from "../../SDK/oneclick";
import { toast } from "react-toastify";
import Paginationnew from "../../Uitiles/Paginationnew";

const STATUS_OPTIONS = ["Active", "Draft", "Disabled"];
const TYPE_OPTIONS = ["Auth", "Login", "Forgot Password", "OTP", "Appointment", "Payment", "Reminder", "Welcome", "Email Verification", "Password Reset", "Appointment Reminder", "Payment Reminder", "OTP Reminder", "Welcome Reminder", "Email Verification Reminder", "Password Reset Reminder"];

function StatusBadge({ status }) {
    const variant = status === "Active" ? "success" : status === "Draft" ? "warning" : "secondary";
    return <Badge bg={variant}>{status}</Badge>;
}

function TemplateForm({ values, onChange, onSubmit, submitLabel, isEdit }) {
    const [errors, setErrors] = useState({});
    const [isUploading, setIsUploading] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const handleChange = (field, value) => {
        onChange({ ...values, [field]: value });
    };



    const handleImage = async (e, type) => {
        const file = e.target.files[0];
        if (file) {
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/x-icon'];
            if (!validTypes.includes(file.type)) {
                setErrors(prev => ({
                    ...prev,
                    [type]: 'Please upload a valid image file (JPEG, PNG, GIF, or ICO)'
                }));
                return;
            }

            setIsUploading(true);
            try {
                const root = "site/templates";
                const status = "public";
                const uploadResult = await OneKlicksFileSDK.uploadFile(root, status, file);

                if (!uploadResult || !uploadResult.fileId) {
                    throw new Error('Failed to upload file');
                }

                const reader = new FileReader();
                reader.onloadend = () => {

                    setImagePreview(reader.result);

                    const imagedata = { file: uploadResult.file.root + "/" + uploadResult.file.fileName, name: file.name };

                    onChange({ ...values, image: JSON.stringify(imagedata) });
                };
                reader.readAsDataURL(file);
            } catch (error) {
                console.error('Error uploading file:', error);
                setErrors(prev => ({
                    ...prev,
                    [type]: 'Failed to upload file. Please try again.'
                }));
            } finally {
                setIsUploading(false);
            }
        }
    };


    return (
        <Form onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
            <Row className="g-3">
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Template Type</Form.Label>
                        <Form.Select
                            value={values.type}
                            style={{ width: "100%" }}
                            onChange={(e) => handleChange("type", e.target.value)}
                            required
                        >
                            <option value="">Select type</option>
                            {TYPE_OPTIONS.map((t) => (
                                <option key={t} value={t}>{t}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Category</Form.Label>
                        <Form.Control
                            placeholder="Enter category"
                            value={values.category}
                            style={{ width: "100%" }}
                            onChange={(e) => handleChange("category", e.target.value)}
                            required
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            placeholder="Enter name"
                            value={values.name}

                            onChange={(e) => handleChange("name", e.target.value)}
                            required
                        />
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <Form.Group>
                        <Form.Label>Template Content SMS</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={6}
                            placeholder="Use variables like {{patient_name}}, {{otp}}, {{date}}"
                            value={values.content}
                            onChange={(e) => handleChange("content", e.target.value)}
                            required
                        />
                        <Form.Text muted>
                            Supported variables example: {'{{patient_name}}'}, {'{{doctor_name}}'}, {'{{appointment_time}}'}
                        </Form.Text>
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <Form.Group>
                        <Form.Label>Template Content WhatsApp</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={6}
                            placeholder="Use variables like {{patient_name}}, {{otp}}, {{date}}"
                            value={values.whatsapp_content}
                            onChange={(e) => handleChange("whatsapp_content", e.target.value)}
                            required
                        />
                        <Form.Text muted>
                            Supported variables example: {'{{patient_name}}'}, {'{{doctor_name}}'}, {'{{appointment_time}}'}
                        </Form.Text>
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <Form.Group>
                        <Form.Label>Template Content Email</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={6}
                            placeholder="Use variables like {{patient_name}}, {{otp}}, {{date}}"
                            value={values.email_content}
                            onChange={(e) => handleChange("email_content", e.target.value)}
                            required
                        />
                        <Form.Text muted>
                            Supported variables example: {'{{patient_name}}'}, {'{{doctor_name}}'}, {'{{appointment_time}}'}
                        </Form.Text>
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <Form.Group className="mb-3">
                        <Form.Label>Email HTML Template (optional)</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={8}
                            placeholder="Enter HTML code for email template..."
                            value={values.html_content}
                            onChange={(e) => handleChange("html_content", e.target.value)}
                        />
                        <Form.Text muted>
                            Enter HTML code for email template. Use variables like {'{{patient_name}}'}, {'{{doctor_name}}'}, {'{{appointment_time}}'}
                        </Form.Text>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Image Upload (optional)</Form.Label>
                        <Form.Control type="file" accept="image/*" onChange={(e) => handleImage(e, 'image')} />
                        {values.image?.preview && JSON.parse(values.image).name && JSON.parse(values.image).file && (
                            <div className="mt-2">
                                <Image src={values.image.preview} alt="preview" thumbnail />
                            </div>
                        )}
                    </Form.Group>
                    {values.type === "Email" && (
                        <Form.Group>
                            <Form.Label>HTML File for Email (optional)</Form.Label>
                            <Form.Control type="file" accept="text/html,.html" onChange={(e) => handleImage(e, 'email_image')} />
                            {values.email_image && JSON.parse(values.email_image).name && JSON.parse(values.email_image).file && (
                                <div className="small text-muted mt-1">Selected: {values.email_image.name}</div>
                            )}
                        </Form.Group>
                    )}
                </Col>

                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Status</Form.Label>
                        <Form.Select
                            value={values.status}
                            style={{ width: "100%" }}
                            onChange={(e) => handleChange("status", e.target.value)}
                            required
                        >
                            {STATUS_OPTIONS.map((s) => (
                                <option key={s} value={s}>{s}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>
                {isEdit && (
                    <>

                        <Col md={12}>
                            <h6>Status Update</h6>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>WhatsApp</Form.Label>
                                <Form.Select
                                    value={values.whatsapp_status}
                                    style={{ width: "100%" }}
                                    onChange={(e) => handleChange("whatsapp_status", e.target.value)}
                                    required
                                >
                                    <option value="Approved">Approved</option>
                                    <option value="Rejected">Rejected</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Deleted">Deleted</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>WhatsApp Template ID</Form.Label>
                                <Form.Control
                                    placeholder="Enter WhatsApp Template ID"
                                    value={values.whatsapp_template_id}

                                    onChange={(e) => handleChange("whatsapp_template_id", e.target.value)}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>SMS</Form.Label>
                                <Form.Select
                                    value={values.sms_status}
                                    style={{ width: "100%" }}
                                    onChange={(e) => handleChange("sms_status", e.target.value)}
                                    required
                                >
                                    <option value="Approved">Approved</option>
                                    <option value="Rejected">Rejected</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Deleted">Deleted</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>SMS Template ID</Form.Label>
                                <Form.Control
                                    placeholder="Enter SMS Template ID"
                                    value={values.sms_template_id}

                                    onChange={(e) => handleChange("sms_template_id", e.target.value)}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Email</Form.Label>
                                <Form.Select
                                    value={values.email_status}
                                    style={{ width: "100%" }}
                                    onChange={(e) => handleChange("email_status", e.target.value)}
                                    required
                                >
                                    <option value="Approved">Approved</option>
                                    <option value="Rejected">Rejected</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Deleted">Deleted</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </>

                )}
            </Row>
            <div className="d-flex justify-content-end mt-4">
                <Button type="submit" variant="primary">{submitLabel}</Button>
            </div>
        </Form>
    );
}

export default function SMSEmalTemplaes() {
    const [search, setSearch] = useState("");
    const [templates, setTemplates] = useState(() => []);
    const [nextId, setNextId] = useState(4);

    const [showAdd, setShowAdd] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showView, setShowView] = useState(false);
    const [activeTab, setActiveTab] = useState("preview");
    const [settings, setSettings] = useState({});
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);


    const [current, setCurrent] = useState(null);
    const [formValues, setFormValues] = useState({
        type: "",
        category: "",
        name: "",
        content: "",
        whatsapp_content: "",
        email_content: "",
        html_content: "",
        status: "Active",
        image: null,
        whatsapp_status: "Pending",
        whatsapp_template_id: "",
        sms_status: "Pending",
        sms_template_id: "",
        email_status: "Pending"
    });

    const resetForm = () => {
        setFormValues({
            type: "",
            category: "",
            name: "",
            content: "",
            whatsapp_content: "",
            email_content: "",
            html_content: "",
            status: "Active",
            image: null,
            whatsapp_status: "Pending",
            whatsapp_template_id: "",
            sms_status: "Pending",
            sms_template_id: "",
            email_status: "Pending"
        });
    };

    useEffect(() => {
        getSettings().then(settings => {
            setSettings(settings);
        });
        getTemplates();
    }, []);

    useEffect(() => {
        getTemplates();
    }, [page, limit]);

    const getTemplates = async () => {
        try {
            const tableSchema = '';
            const tableName = 'sms_email_whatsapp_templates';
            const conditions = {};
            const orderBy = '';
            const search = '';
            const pagination = {
                page: page,
                limit: limit
            };
            const margedata = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (response.success) {
                console.log('getTemplates response', response);

                setTemplates(response.data);
                setNextId(response.data.length + 1);
                setTotalPages(response.totalPages);
            } else {
                toast.error('Failed to get templates');
            }
        } catch (error) {
            toast.error('Failed to get templates');
        }
    };

    const filtered = useMemo(() => {
        const q = search.trim().toLowerCase();
        if (!q) return templates;
        return templates.filter((t) =>
            ["" + t.id, t.type, t.category, t.name, t.content, t.status]
                .filter(Boolean)
                .join(" ")
                .toLowerCase()
                .includes(q)
        );
    }, [search, templates]);

    const openAdd = () => { resetForm(); setShowAdd(true); };
    const submitAdd = async () => {
        try {
            setTemplates((prev) => [...prev, { id: nextId, ...formValues }]);
            setNextId((n) => n + 1);
            const tableSchema = '';
            const tableName = 'sms_email_whatsapp_templates';
            const data = formValues;
            const conditions = {};
            const response = await oneKlicks.create(tableSchema, tableName, data, conditions);
            if (response.success) {
                toast.success('Template added successfully');
                getTemplates();
                setShowAdd(false);
            } else {
                toast.error(`Failed to add template: ${response.message}`);
            }
        } catch (error) {
            toast.error(`Failed to add template: ${error.message}`);
        }

    };

    const openEdit = (tpl) => { setCurrent(tpl); setFormValues({ ...tpl }); setShowEdit(true); };
    const submitEdit = async () => {
        try {
            setTemplates((prev) => prev.map((t) => (t.id === current.id ? { ...formValues } : t)));
            setCurrent(null);
            const tableSchema = '';
            const tableName = 'sms_email_whatsapp_templates';
            const { created_at, updated_at, ...data } = formValues; // created_at and updated_at REMOVE
            console.log('data', data);
            const conditions = { id: current.id };
            const response = await oneKlicks.update(tableSchema, tableName, data, conditions);
            if (response.success) {
                toast.success('Template updated successfully');
                getTemplates();
                setShowEdit(false);
            } else {
                toast.error(`Failed to update template: ${response.message}`);
            }
        } catch (error) {
            toast.error(`Failed to update template: ${error.message}`);
        } finally {
            setShowEdit(false);
        }
    };

    const openView = (tpl) => { setCurrent(tpl); setActiveTab("preview"); setShowView(true); };

    const handleDelete = async (tpl) => {
        if (window.confirm("Delete this template?")) {
            try {
                setTemplates((prev) => prev.filter((t) => t.id !== tpl.id));
                const tableSchema = '';
                const tableName = 'sms_email_whatsapp_templates';
                const conditions = { id: tpl.id };
                const response = await oneKlicks.delete(tableSchema, tableName, conditions);
                if (response.success) {
                    toast.success('Template deleted successfully');
                }
            } catch (error) {
                toast.error(`Failed to delete template: ${error.message}`);
            } finally {
                getTemplates();
            }
        }
    };

    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2  mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">Templates</h5>
                                <Badge bg="info">SMS / Email / WhatsApp</Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <InputGroup className="p-0" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                                    <Form.Control
                                        placeholder="Search..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </InputGroup>
                                <Button variant="primary" style={{ height: 50, width: 150 }} onClick={openAdd}>+ Add Template</Button>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <Table hover size="sm" className="mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th style={{ width: 70 }}>ID</th>
                                        <th>Type</th>
                                        <th>Category</th>
                                        <th>Name</th>
                                        <th>Template</th>
                                        <th style={{ width: 120 }}>Status</th>
                                        <th style={{ width: 180 }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filtered.length === 0 && (
                                        <tr>
                                            <td colSpan={7} className="text-center text-muted py-4">No templates found.</td>
                                        </tr>
                                    )}
                                    {filtered.map((t) => (
                                        <tr key={t.id}>
                                            <td>#{t.id}</td>
                                            <td>{t.type}</td>
                                            <td>{t.category}</td>
                                            <td>{t.name}</td>
                                            <td className="text-truncate" style={{ maxWidth: 320 }}>{t.content}</td>
                                            <td><StatusBadge status={t.status} /></td>
                                            <td>
                                                <div className="d-flex" style={{ gap: 8 }}>
                                                    <Button size="sm" variant="outline-secondary" onClick={() => openView(t)}>View</Button>
                                                    <Button size="sm" variant="outline-primary" onClick={() => openEdit(t)}>Edit</Button>
                                                    <Button size="sm" variant="outline-danger" onClick={() => handleDelete(t)}>Delete</Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>

                        <Paginationnew
                            currentPage={page}
                            totalPages={totalPages}
                            handlePageChange={setPage}
                        />
                    </div>
                </div>

                <Modal show={showAdd} onHide={() => setShowAdd(false)} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Template</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <TemplateForm
                            values={formValues}
                            onChange={setFormValues}
                            onSubmit={submitAdd}
                            submitLabel="Create"
                            isEdit={false}
                        />
                    </Modal.Body>
                </Modal>

                <Modal show={showEdit} onHide={() => setShowEdit(false)} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Template</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <TemplateForm
                            values={formValues}
                            onChange={setFormValues}
                            onSubmit={submitEdit}
                            submitLabel="Update"
                            isEdit={true}
                        />
                    </Modal.Body>
                </Modal>

                <Modal show={showView} onHide={() => setShowView(false)} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Template Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {current && (
                            <div>
                                {/* Template Info */}
                                <Row className="mb-4">
                                    <Col md={4}><div className="text-muted">ID</div><div>#{current.id}</div></Col>
                                    <Col md={4}><div className="text-muted">Type</div><div>{current.type}</div></Col>
                                    <Col md={4}><div className="text-muted">Status</div><div><StatusBadge status={current.status} /></div></Col>
                                </Row>
                                <Row className="mb-4">
                                    <Col md={6}><div className="text-muted">Category</div><div>{current.category}</div></Col>
                                    <Col md={6}><div className="text-muted">Name</div><div>{current.name}</div></Col>
                                </Row>

                                {/* Tabs for different preview types */}
                                <Nav variant="tabs" className="mb-3" activeKey={activeTab} onSelect={setActiveTab}>
                                    <Nav.Item>
                                        <Nav.Link eventKey="preview">Preview</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="whatsapp">WhatsApp</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="sms">SMS</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="email">Email</Nav.Link>
                                    </Nav.Item>
                                </Nav>

                                {/* Tab Content */}
                                {activeTab === "preview" && (
                                    <div>
                                        {current.image?.preview && (
                                            <div className="mb-3">
                                                <div className="text-muted">Image</div>
                                                <Image src={current.image.preview} alt="template" thumbnail />
                                            </div>
                                        )}
                                        <div className="mb-2"><div className="text-muted">SMS Content</div></div>
                                        <pre className="p-3 bg-light border rounded" style={{ whiteSpace: "pre-wrap" }}>{current.content}</pre>

                                        {current.whatsapp_content && (
                                            <div className="mt-3">
                                                <div className="text-muted">WhatsApp Content</div>
                                                <pre className="p-3 bg-success text-white rounded" style={{ whiteSpace: "pre-wrap" }}>{current.whatsapp_content}</pre>
                                            </div>
                                        )}

                                        {current.email_content && (
                                            <div className="mt-3">
                                                <div className="text-muted">Email Content</div>
                                                <pre className="p-3 bg-light border rounded" style={{ whiteSpace: "pre-wrap" }}>{current.email_content}</pre>
                                            </div>
                                        )}

                                        {current.html_content && (
                                            <div className="mt-3">
                                                <div className="text-muted">HTML Template</div>
                                                <div className="p-3 bg-light border rounded">
                                                    <div dangerouslySetInnerHTML={{ __html: current.html_content }} />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {activeTab === "whatsapp" && (
                                    <div>
                                        <Row className="mb-3">
                                            <Col md={6}><div className="text-muted">WhatsApp Status</div><div><StatusBadge status={current.whatsapp_status} /></div></Col>
                                            <Col md={6}><div className="text-muted">Template ID</div><div>{current.whatsapp_template_id}</div></Col>
                                        </Row>
                                        <div className="mb-3">
                                            <div className="text-muted mb-2">WhatsApp Preview</div>
                                            <div className="phone-container">
                                                <div className="phone-screen">
                                                    <div className="phone-header">
                                                        <div className="back-arrow">←</div>
                                                        <ImageShow
                                                            url={settings.favicon_url}
                                                            height={30}
                                                            width={30}
                                                            alt="WhatsApp"
                                                            title="WhatsApp"
                                                            style={{ borderRadius: "50%", backgroundColor: "#ffffff" }}
                                                        />
                                                        <div className="contact-info">
                                                            <div className="contact-name">MeddyList</div>
                                                            <div className="contact-status">{settings.site_name}</div>
                                                        </div>
                                                        <div className="menu-dots">⋮</div>
                                                    </div>
                                                    <div className="phone-messages">
                                                        <div className="message-bubble message-sent">

                                                            {current.image && <ImageShow url={JSON.parse(current.image).file} style={{ borderRadius: "5px" }} />}
                                                            {current.whatsapp_content || current.content}
                                                            <div className="message-time">12:34</div>
                                                        </div>
                                                    </div>
                                                    <div className="phone-input">
                                                        <input type="text" placeholder="Type a message" />
                                                        <button className="send-btn">→</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {activeTab === "sms" && (
                                    <div>
                                        <Row className="mb-3">
                                            <Col md={6}><div className="text-muted">SMS Status</div><div><StatusBadge status={current.sms_status} /></div></Col>
                                            <Col md={6}><div className="text-muted">Template ID</div><div>{current.sms_template_id}</div></Col>
                                        </Row>
                                        <div className="mb-3">
                                            <div className="text-muted mb-2">SMS Preview</div>
                                            <div className="sms-container">
                                                <div className="sms-screen">
                                                    <div className="sms-header">
                                                        Messages
                                                    </div>
                                                    <div className="sms-messages">
                                                        <div className="sms-message">
                                                            {current.content}
                                                        </div>
                                                    </div>
                                                    <div className="sms-input">
                                                        <input type="text" placeholder="Text message" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {activeTab === "email" && (
                                    <div>
                                        <Row className="mb-3">
                                            <Col md={6}><div className="text-muted">Email Status</div><div><StatusBadge status={current.email_status} /></div></Col>
                                        </Row>
                                        <div className="mb-3">
                                            <div className="text-muted mb-2">Email Preview</div>
                                            <div className="email-container">
                                                <div className="email-header">
                                                    <div className="email-subject">{current.name}</div>
                                                    <div className="email-meta">
                                                        <span>From: MeddyList &lt;noreply@meddylist.com&gt;</span>
                                                        <span>To: {`{{patient_email}}`}</span>
                                                    </div>
                                                </div>
                                                <div className="email-body">
                                                    {current.html_content ? (
                                                        <div dangerouslySetInnerHTML={{ __html: current.html_content }} />
                                                    ) : (
                                                        <div style={{ whiteSpace: "pre-wrap" }}>{current.email_content || current.content}</div>
                                                    )}
                                                </div>
                                                {current.html_content && (
                                                    <div className="email-footer">
                                                        HTML Template: Custom HTML Code
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </Modal.Body>
                </Modal>
            </div>
        </div>

    );
}


